export default __webpack_public_path__ + "static/media/music logo.e32a0a65.png";